import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import useWindowDimensions from "../WindowSize";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import ServiceList from "./elements/services/ServiceList";
import Skeleton from "react-loading-skeleton";
import Repair from "./elements/Repair";
import PackageList from "./elements/packages/PackageList";
import RepairSelection from "./elements/RepairSelection";
import NewRepair from "./elements/NewRepair";
import { packageFlow } from "../../lib/config";
import TyresListing from "./elements/tyresListing/TyresListing";
import { isMobile } from "react-device-detect";
import NewTyres from "./elements/NewTyres";

const ProductList = ({
  setTypeTwo,
  setTypeOne,
  setServiceData,
  serviceData,
  show,
  setShow,
  variants,
  globalData,
  getCarBrandModal,
  apiData,
  getModel,
  getWorkshopFilterMap,
  id,
  variantId,
  type,
  cart,
}) => {
  const [categoryAreaSize, setCategoryAreaSize] = useState(0);

  const handleShow = () => {};
  return (
    <div
      className={cart.workshop?.Name ? "product-area-new mb-5" : "mb-5 row"}
      style={{ paddingTop: categoryAreaSize }}
    >
      <div className="col-md-12 custompr-col">
        {id === 10 ? (
          <NewRepair
            id={id}
            show={show}
            setShow={setShow}
            handleShow={handleShow}
            getWorkshopFilterMap={getWorkshopFilterMap}
            variants={variants}
            getModel={getModel}
            apiData={apiData}
            globalData={globalData}
            getCarBrandModal={getCarBrandModal}
            setTypeOne={setTypeOne}
            setTypeTwo={setTypeTwo}
            setServiceData={setServiceData}
            serviceData={serviceData}
            variantId={variantId}
          />
        ) : id === 17 ? (
          <NewTyres />
        ) : (
          <>
            {type === packageFlow ? (
              <PackageList
                setTypeOne={setTypeOne}
                setTypeTwo={setTypeTwo}
                id={id}
                setServiceData={setServiceData}
                serviceData={serviceData}
                show={show}
                setShow={setShow}
                handleShow={handleShow}
                getWorkshopFilterMap={getWorkshopFilterMap}
                variants={variants}
                getModel={getModel}
                apiData={apiData}
                globalData={globalData}
                getCarBrandModal={getCarBrandModal}
                variantId={variantId}
              />
            ) : (
              <>
                {variants?.length != 0 ? (
                  <ServiceList
                    setTypeOne={setTypeOne}
                    setTypeTwo={setTypeTwo}
                    id={id}
                    setServiceData={setServiceData}
                    serviceData={serviceData}
                    show={show}
                    setShow={setShow}
                    handleShow={handleShow}
                    getWorkshopFilterMap={getWorkshopFilterMap}
                    variants={variants}
                    getModel={getModel}
                    apiData={apiData}
                    globalData={globalData}
                    getCarBrandModal={getCarBrandModal}
                    variantId={variantId}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      zIndex: 0,
                    }}
                  >
                    <Skeleton
                      style={{
                        width: isMobile ? "95vw" : "55vw",
                        height: "170px",
                      }}
                    />
                    <Skeleton
                      style={{
                        width: isMobile ? "95vw" : "55vw",
                        height: "170px",
                      }}
                    />
                    <Skeleton
                      style={{
                        width: isMobile ? "95vw" : "55vw",
                        height: "170px",
                      }}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
        {/* {id != 10 && <Row className="product-header">
                    <Col>
                        <div className="product-header-text">Service Packages</div>
                    </Col>
                </Row>} */}
      </div>
    </div>
  );
};

export default ProductList;
